//个案管理 任务提醒 接口

//引入接口文档
import req from '@/utils/req.js'


//个案的任务分页条件查询
export function api_list(params) {
    return req.get("/admin/app-version", params);
}

// 个案任务分页条件查询
export function api_list_page(params) {
    return req.get("admin/app-version/page", params);
}

//个案的任务分页条件查询
export function api_add(params) {
    return req.post("/admin/app-version/addNewVersion", params);
}


// 列表
export function pageList(params) {
    return req.get("/biz/synergy-relation/page", params);
}

//机构列表
export function orgList(params) {
    return req.get("/biz/synergy-relation/org-list", params);
}

//科室列表
export function departmentList(params) {
    return req.post("/admin/open-department/list", params);
}

//团队列表
export function doctorTeamList(params) { 
    return req.get("/admin/doctor-team", params);
}

//医生列表
export function doctorTeamMemberTeamList(params) {
    return req.get("/admin/doctor-team-member/getListByTeamId", params);
}

//添加
export function synergyRelationAdd(params) {
    return req.post("/biz/synergy-relation", params);
}

//编辑
export function synergyRelationEdit(params) { 
    return req.put("/biz/synergy-relation", params);
}

//详情
export function synergyRelationDetail(params) { 
    return req.get(`/biz/synergy-relation/${params.id}`);
}

// 启用
export function state(params) { 
    return req.put("/biz/synergy-relation/state", params);
}

//删除
export function synergyRelationDelete(params) { 
    return req.delete(`/biz/synergy-relation/${params.id}`);
}




